var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRfidSettingsSm = function SvgRfidSettingsSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "RFID Settings",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.618 17.672H3.999V4.052h5.76v.98h-4.78v11.66h11.66v-4.758h.979v5.737zm-3.183-7.956h-.979v-.5a1.082 1.082 0 0 0-1.083-1.076h-.49v-.981h.49a2.063 2.063 0 0 1 2.062 2.059v.5zm3.152 0h-.979v-.517a4.224 4.224 0 0 0-4.219-4.22h-.49v-.98h.49a5.2 5.2 0 0 1 5.2 5.2v.514z",
    "data-name": "Path 11565"
  })));
};
export default SvgRfidSettingsSm;